import React from 'react'
import LocationInput from 'sprockets_react/components/LocationInput'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.Location = React.createClass({
  job: Job,

  getInitialState: function() {
    return this.job.Store.getSuburb()
  },

  componentDidMount: function() {
    this.onValidation()
    this.job.Store.addChangeListener(this.updateState)
  },

  componentWillUnmount: function() {
    this.job.Store.removeChangeListener(this.updateState)
  },

  updateState: function(data) {
    this.setState(this.job.Store.getSuburb())
  },

  handleAutocompleteSelection: function( event, response ) {
    Job.Actions.updateLocation({ id: response.item.id, value: response.item.value })

    if (this.props.customForm) {
      let selectedSuburb = document.querySelector('.selected-suburb')
      selectedSuburb.value = this.state.suburb_id
    }
  },

  handleLocationChange: function(event) {
    Job.Actions.updateLocation({ id: 0, value: event.target.value })
  },

  onValidation: function() {
    let wizard = JobWizardMobile;

    $(function() { // doc ready
      wizard.Validator.addField(
        'location',
        {
          threshold: 99999,
          validators: {
            callback: {
              callback: function(fieldValue, validator) {
                return Job.Data.suburb_id !== 0
              },
              message: "Please enter your Postcode or Suburb and select the matching one from the drop-down menu"
            }
          }
        }
      )
    }) // end doc ready
  },

  render: function() {
    return (
      <LocationInput
        suburb={this.state.suburb}
        suburbId={this.state.suburb_id}
        handleAutocompleteSelection={this.handleAutocompleteSelection}
        handleLocationChange={this.handleLocationChange}
        guId={SS.utils.generateGuid()}
      />
    )
  },
})
